import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ICharacterCompleted } from 'src/app/store/characterState/characterState.reducer';

@Component({
  selector: 'app-character-energy-scale',
  templateUrl: './character-energy-scale.component.html',
  styleUrls: ['./character-energy-scale.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharacterEnergyScaleComponent implements OnInit {
  @Input() character: ICharacterCompleted | undefined | null;
  @Input() result: { quantity: number; quantityInPercent: number } | undefined;
  constructor() {}

  ngOnInit(): void {}
}
